module.exports = __webpack_public_path__ + "static/media/stockhausen_polymorph_12.b2aa7069.jpg";